module.exports = __webpack_public_path__ + "static/media/yourdata_01.4cd4f1f4.jpg";